// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import ParalaxScroller from '../../../components/paralaxScroller/ParalaxScroller';
import MenuPage from '../../../components/paralaxScroller/MenuPage';
import KeyFigures from './items/key-figures/KeyFigures';
import FlowMap from './FlowMap';
import Modal from '../../../components/Modal';
import FootfallDoorModal from './components/FootfallDoorModal';
import type { FootFallDoors } from '../../../types/geminiType';

type Props = {}

type State = {
  modalOpen: boolean,
  footfallData: FootFallDoors,
  footfallDataList: FootFallDoors[],
}

class MallFlow extends React.Component<Props, State> {
  state: State = {
    modalOpen: false,
    footfallData: null,
    footfallDataList: [],
  };

  toogleModalOpen = () =>
    this.setState(previousState => ({ modalOpen: !previousState.modalOpen }))

  selectFootFallDoor = (footfallData: FootFallDoors) => {
    this.setState({ footfallData, modalOpen: true });
  }

  render() {
    return (
      <div className="flow-page">
        <Modal
          isOpen={this.state.modalOpen}
          onClose={this.toogleModalOpen}
          title={this.state.footfallData && this.state.footfallData.sensorLabel}
        >
          <FootfallDoorModal
            footfallData={this.state.footfallData}
            footfallDataList={this.state.footfallDataList}
          />
        </Modal>
        <FlowMap
          selectFootfallDoor={this.selectFootFallDoor}
          fetchedFootfallDoor={footfallDataList => this.setState({ footfallDataList })}
        />
        <ParalaxScroller
          className="scrollable-content"
          scrollSelf
        >
          <div className="mall-datas">
            <MenuPage id="key-figure">
              <KeyFigures footfallDataList={this.state.footfallDataList} />
            </MenuPage>
          </div>
        </ParalaxScroller>
      </div>
    );
  }
}

export default withRouter(MallFlow);
